import { Button, Hide, Icon, Image, Show } from '@chakra-ui/react'
import { ReactComponent as WalletIcon } from 'assets/illustrations/svg/wallet.svg'
import { useJoeProfilePicturePlaceholder } from 'hooks/useImage'
import React from 'react'
import { useWalletModalToggle } from 'state/application/hooks'
import { useAccount } from 'wagmi'

const Web3Status = (): JSX.Element => {
  const { address: account, isConnected } = useAccount()
  const toggleWalletModal = useWalletModalToggle()
  const joePfpPlaceholderUrl = useJoeProfilePicturePlaceholder(account)

  return isConnected ? (
    <Image
      src={joePfpPlaceholderUrl}
      alt="Profile picture"
      boxSize="2.5rem"
      borderRadius="full"
      objectFit="contain"
    />
  ) : (
    <>
      <Hide below="sm">
        <Button
          variant="outline"
          h="40px"
          borderRadius="12px"
          borderWidth="1px"
          fontWeight="regular"
          onClick={toggleWalletModal}
        >
          Connect Wallet
        </Button>
      </Hide>
      <Show below="sm">
        <Button
          variant="unstyled"
          display="flex"
          alignItems="center"
          justifyContent="center"
          boxSize="2.75rem"
          border="2px solid"
          borderColor="border"
          borderRadius="full"
          bg="transparent"
          onClick={toggleWalletModal}
        >
          <Icon as={WalletIcon} stroke="textPrimary" />
        </Button>
      </Show>
    </>
  )
}

export default Web3Status
